import type { BuildingZone } from '@kaeliux/shared';

/**
 * Shared per-zone display strings/classes used by both `PlanetSurface` (zone
 * banners) and `ZoneStrip` (DS-16 compass). Extracted so the two never carry
 * their own copies of the same literal out of sync with each other.
 */
export const ZONE_LABEL: Record<BuildingZone, string> = {
    resource: 'Resource',
    industry: 'Industry',
    military: 'Military',
};

export const ZONE_TEXT_CLASS: Record<BuildingZone, string> = {
    resource: 'text-zone-resource',
    industry: 'text-zone-industry',
    military: 'text-zone-military',
};

export const ZONE_BG_CLASS: Record<BuildingZone, string> = {
    resource: 'bg-zone-resource',
    industry: 'bg-zone-industry',
    military: 'bg-zone-military',
};
